import React, { useContext } from 'react';
import { AccountContext } from '../../context';
import { useTranslation } from 'react-i18next';
import Footer from '../Footer';
import { ACCOUNT_LANGUAGES_LIST } from '../../helpers/languages';
import { useIblTranslation } from '../../../../i18n';

const Basic = () => {

  const DEFAULT_LANG = 'en'
  const {
    userData,
    onUserDataChange,
    userMetaData,
    onUserMetaDataChange,
    METADATANAMES,
    handleSubmit,
    isSubmitting,
  } = useContext(AccountContext);

  const { t } = useTranslation('library');
  const { languages } = useIblTranslation();

  const handleInputChange = (e) => {
    if (METADATANAMES.includes(e?.target?.name)) {
      onUserMetaDataChange({
        ...userMetaData,
        [e?.target?.name]: e?.target?.value,
      });
    } else {
      onUserDataChange({
        ...userData,
        [e?.target?.name]: e?.target?.value,
      });
    }
  };


  return (
    <div data-name={'basic'} className="manage-account-form-block w-form">
      <form
        onSubmit={handleSubmit}
        id="email-form-2"
        name="email-form-2"
        data-name={'Email Form 2'}
        method="get"
        className="manage-account-form"
        data-wf-page-id="65aec9c9e13ed74d8bfffe77"
        data-wf-element-id="f097fb24-dc47-4961-e662-a4078f3e5401"
      >
        <div className="w-layout-hflex-account-ui tabs-content basic-information-block">
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('Full Name')}
              </label>
              <label htmlFor="name" className="form-input-label required">
                *
              </label>
            </div>
            <div className="form-input-desc hidden">{t('Your full name')}</div>
            <input
              className="form-input w-input"
              maxLength={256}
              name="name"
              value={userMetaData?.name || ''}
              onChange={handleInputChange}
              data-name={'Organisation Name 3'}
              placeholder=""
              custom-value="Personal"
              type="text"
              id="organisation-name-3"
            />
          </div>
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('Email')}
              </label>
            </div>
            <div className="form-input-desc hidden">
              {t('A confirmation link would be sent to you immediately')}
            </div>
            <input
              className="form-input w-input"
              maxLength={256}
              value={userMetaData?.email || ''}
              name="email"
              onChange={handleInputChange}
              data-name={'Organisation Name 3'}
              placeholder=""
              custom-value="Personal"
              type="email"
              id="organisation-name-3"
            />
            <div className="text-error hidden">{t('Minimum 8 characters')}</div>
          </div>
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('Username')}
              </label>
            </div>
            <div className="form-input-desc hidden">
              {t('A confirmation link would be sent to you immediately')}
            </div>
            <input
              className="form-input disabled w-input"
              maxLength={256}
              disabled={true}
              readOnly={true}
              name="user_nicename"
              value={userData?.user_nicename || ''}
              onChange={handleInputChange}
              data-name={'Organisation Name 3'}
              placeholder=""
              custom-value="Personal"
              type="text"
              id="organisation-name-3"
            />
            <div className="text-error hidden">{t('Minimum 8 characters')}</div>
          </div>
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('Title')}
              </label>
            </div>
            <div className="form-input-desc hidden">{t('Must be unique')}</div>
            <input
              className="form-input w-input"
              maxLength={256}
              name="bio"
              value={userMetaData?.bio || ''}
              onChange={handleInputChange}
              data-name={'Organisation Name 3'}
              placeholder=""
              custom-value="Personal"
              type="text"
              id="organisation-name-3"
            />
            <div className="text-error hidden">{'Minimum 8 characters'}</div>
          </div>
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('About')}
              </label>
            </div>
            <div className="form-input-desc hidden">{t('Must be unique')}</div>
            <div className="text-error hidden">{t('Minimum 8 characters')}</div>
            <textarea
              name="about"
              value={userMetaData?.about || ''}
              onChange={handleInputChange}
              placeholder=""
              maxLength={5000}
              id="field"
              data-name={'Field'}
              className="textarea w-input"
            ></textarea>
          </div>
          <div className="w-layout-vflex account-input-block">
            <div className="w-layout-hflex label-block"><label htmlFor="name-6"
                                                               className="form-input-label">Language</label></div>
            <select id="field-2" name="language" data-name="Field 2"
                    className="select-field w-select account-language-dropdown" onChange={handleInputChange}>
              {
                Object.entries(languages).map(([key, value]) => (
                  <option selected={key === (userMetaData?.language ?? DEFAULT_LANG)}
                          value={key}>{value}</option>
                ))
              }
            </select>
          </div>
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('Public Profile')}
              </label>
            </div>
            <div className="form-input-desc hidden">{t('Must be unique')}</div>
            <div className="text-error hidden">{t('Minimum 8 characters')}</div>
            <label className="w-checkbox">
              <input
                type="checkbox"
                id="checkbox"
                checked={!!userMetaData?.is_profile_public}
                name="is_profile_public"
                onChange={(e) =>
                  handleInputChange({
                    target: {
                      name: 'is_profile_public',
                      value: !userMetaData?.is_profile_public,
                    },
                  })
                }
                data-name={'Checkbox'}
                className="w-checkbox-input"
              />
              <label className="w-form-label" htmlFor="checkbox">
                {t('Make Profile Public')}
              </label>
            </label>
          </div>
        </div>
        <Footer isSubmitting={isSubmitting} handleSubmit={handleSubmit} />
      </form>
      <div className="w-form-done">
        <div>{t('Thank you! Your submission has been received!')}</div>
      </div>
      <div className="w-form-fail">
        <div>{t('Oops! Something went wrong while submitting the form.')}</div>
      </div>
    </div>
  );
};

export default Basic;
